// Pure storage policy for the native-app prompt. Kept separate from the
// browser/platform checks in appPrompt.ts so the backwards-compatible
// dismissal contract can be regression-tested without a DOM.

export const APP_PROMPT_STORAGE_KEY = 'getAppPrompt';
export const APP_PROMPT_SNOOZE_MS = 30 * 86_400_000;

type StoredDismissal = { until?: unknown; dismissed?: unknown };

/**
 * Whether a persisted prompt record allows the prompt to be shown now.
 *
 * Older releases stored only `{ until }`; current releases store
 * `{ dismissed: true }` after an App Store click. Invalid or half-written
 * records fail open so they cannot permanently hide the prompt.
 */
export function storedAppPromptAllowsDisplay(raw: string | null, now = Date.now()): boolean {
  if (!raw) return true;

  let stored: StoredDismissal;
  try {
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return true;
    stored = parsed as StoredDismissal;
  } catch {
    return true;
  }

  if (stored.dismissed === true) return false;
  if (typeof stored.until !== 'number' || !Number.isFinite(stored.until)) return true;
  return now > stored.until;
}

export function serializeAppPromptSnooze(now = Date.now()): string {
  return JSON.stringify({ until: now + APP_PROMPT_SNOOZE_MS });
}

export function serializePermanentAppPromptDismissal(): string {
  return JSON.stringify({ dismissed: true });
}
